'use strict';


app.factory('Venue', ['$http', '$rootScope', 'Helper', 'env_config',
    function ($http, $rootScope, Helper, env_config) {
        var service = {};


        /**
         * get venues that are nearby selected user
         * 
         * @param  Object   user
         * @param  Object   pagination
         * @param  Function callback
         */
        service.get = function (user, pagination, callback) {
        		
            $http({
            	url: env_config.api_url + 'venues/nearby',
            	method: 'GET',
            	params: {
                    width  : user.width,
            		height : user.height,
            		limit  : pagination.limit,
            		offset : pagination.offset,
                    'filter[service_types_id]' : 1, // get only venues that have "Pickup At The Bar" set
                    'filter[spots_type]'       : 1, // get only venues that have a type of "venue"
            	}
            })
            .success(function (resp, status) {
                callback(resp, status);
            })
            .error(function(resp, status){
                callback(resp, status);
            });
        };


        /**
         * get service type discount
         *
         * @param Number
         */
        service.getDiscount = function(){
            var selected_venue = $rootScope.globals.selectedVenue;

            if(typeof selected_venue == 'undefined') return 0;

            return this.getServiceTypeDiscountFor('pickupathebar');
        }


        /**
         * get service type discount for pickupathebar | bringtotable | takeaway
         * 
         * @param  String  type
         * @return Number  discount
         */
        service.getServiceTypeDiscountFor = function(type){
            var discount = 0;
            var venue_services = $rootScope.globals.selectedVenue.service_type;

            angular.forEach(venue_services, function(venue_service) {
                if( venue_service.type == type )
                    discount = Helper.roundNumber(venue_service.discount, 2);
            });

            return discount;
        }


        /**
         * check if service type exists
         * pickupathebar | bringtotable | takeaway
         * 
         * @param   String  type
         * @param   Array   venue_services
         * @return  Number  discount
         */
        service.checkIfServiceTypeExists = function(type, venue_services){
            var exists = false;

            if( ! venue_services && ! $rootScope.globals.selectedVenue ){
                return false;
            }

            angular.forEach(venue_services, function(venue_service) {
                if( venue_service.type == type )
                    exists = true;
            });

            return exists;
        }


        /**
         * get service fee
         * 
         * if user, selected friend and selected venue have the same venue id
         * than return service fee (fee) 
         * else return gift fee
         * 
         * @return Number
         */
        service.getServiceFee = function(){
            var current_user_venue_id  = $rootScope.globals.currentUser.thirsty;
            var selected_user_venue_id = $rootScope.globals.selectedUser.thirsty;
            var selected_venue_id      = $rootScope.globals.selectedVenue.id;

            if( current_user_venue_id == selected_user_venue_id && selected_user_venue_id == selected_venue_id ) {

                // yep, use service fee
                return Helper.roundNumber($rootScope.globals.selectedVenue.fee, 2);
            }

            // nope, it's a gift, use gift_fee
            return Helper.roundNumber($rootScope.globals.selectedVenue.gift_fee, 2);
        }


        /**
         * get single venue by id
         *
         * @param  Integer venue_id
         * @return Object
         */
        service.getSingle = function(venue_id, callback){
            $http.get(env_config.api_url + 'venues/public/'+venue_id)
                .success(function (resp, status){
                    callback(resp, status);
                })
                .error(function(resp, status){
                    callback(resp, status);
                });
        }


        return service;
    }]);